const adobeLaunchEnvironments = {
    Production: 'https://assets.adobedtm.com/2f3ab3feab3d/ad943721620d/launch-1aafb95a572f.min.js',
    Development: 'https://assets.adobedtm.com/2f3ab3feab3d/ad943721620d/launch-b6c74403b1f4-development.min.js',
    QATesting: 'https://assets.adobedtm.com/2f3ab3feab3d/ad943721620d/launch-bd67bbf9f5b2-development.min.js',
    QASignOff: 'https://assets.adobedtm.com/2f3ab3feab3d/ad943721620d/launch-b462c247e083-development.min.js',
    EBF: 'https://assets.adobedtm.com/2f3ab3feab3d/ad943721620d/launch-edcefac19f66-development.min.js',
    Staging: 'https://assets.adobedtm.com/2f3ab3feab3d/ad943721620d/launch-20d12e7e1f88-staging.min.js',
    SOTDevelopment: 'https://assets.adobedtm.com/2f3ab3feab3d/ad943721620d/launch-5d39811ebd71-development.min.js'
};

export { adobeLaunchEnvironments };
